import { Card, Shimmer, Flex } from '@/_components';
import type { FC } from 'react';
import type { LoadingCardProps } from './LoadingCard.types';

export const LoadingCard: FC<LoadingCardProps> = () => {
  return (
    <Card padding={12} gap={6}>
      <Flex isColumn={true} gap={4}>
        <Shimmer height={32} width={240} paddingTop={4} paddingBottom={4} />
        <Shimmer height={20} width={160} paddingTop={4} paddingBottom={4} />
      </Flex>
      <Flex gap={6} isColumn={true}>
        <Flex gap={4}>
          <Shimmer height={24} width={24} isRounded={true} />
          <Shimmer height={24} width={120} paddingTop={4} paddingBottom={4} />
        </Flex>
        <Flex gap={4}>
          <Shimmer height={24} width={24} isRounded={true} />
          <Shimmer height={24} width={120} paddingTop={4} paddingBottom={4} />
        </Flex>
        <Flex gap={4}>
          <Shimmer height={24} width={24} isRounded={true} />
          <Shimmer height={24} width={120} paddingTop={4} paddingBottom={4} />
        </Flex>
      </Flex>
    </Card>
  );
};
